module.exports = __webpack_public_path__ + "static/media/layoutViews.8ae65de4.png";